import React, { Component } from 'react';
import config from '../../../config';

let $ = window.jQuery;
let Bloodhound = window.Bloodhound;
let Handlebars = window.Handlebars;

export default class HeaderSearch extends Component {

    setupTypeAhead = () => {
        // Typeahead
        let patients = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: config.apiUrl + 'fuzzy-patient-search?q=%QUERY',
                wildcard: '%QUERY',
                filter: function(data) {      // <-- should use `filter`
                    return data;
                }
            }
        });
        
        $('#remote2 .typeahead2').typeahead(null, {
            name: 'patients',
            display: 'name',
            source: patients,
            hint: true,
            highlight: true,
            minLength: 2,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    'No Results Found',
                    '</div>'
                ].join('\n')),
                suggestion: Handlebars.compile([
                    '<div class="media">',
                        '<div class="pull-left">',
                            '<div class="media-object">',
                                '<img src="'+config.staticFiles+'{{image}}" width="30" class="img-circle" height="30" style="border: 1px solid #ddd" onerror="this.onerror=null;this.src=\'/images/generic_profile_pic.png\'"/>',
                            '</div>',
                        '</div>',
                        '<div class="media-body">',
                            '<h4 class="media-heading" style="font-size: 13px">{{name}}</h4>',
                            '<p style="font-size: 12px">{{id}}</p>',
                        '</div>',
                    '</div>'
                ].join(''))
            }
        }).on('typeahead:selected', (obj, datum) => {
            this.context.router.push(`/patients/${datum.id}`);

            window.location = '/patients/' + datum.id; // temporary fix
            
            $('#remote2 .typeahead2').typeahead('val', '');
        }).on('typeahead:autocomplete', (obj, datum) => {
            this.context.router.push(`/patients/${datum.id}`);

            $('#remote2 .typeahead2').typeahead('val', '');
        }).on('typeahead:change', (obj, datum) => {
            console.log(datum.id);
        });
    };

    componentDidMount() {
        this.setupTypeAhead();
        
        $('.tt-hint, .tt-input').on('focusout', () => { // issue: when focusout typeahead is not closing
            $('#remote2 .typeahead2').typeahead('close');
        })
    }

    render() {
        return (
            <form className="col-md-4 col-sm-4 col-xs-8" action="#" method="GET" style={{ height: '100%' }}>
                <div className="form-group" id="remote2" style={{ marginTop: '15px' }}>
                    <div className="col-md-8">
                        <div className="input-icon right">
                            <i className="icon-magnifier"/>
                            <input type="text" className="form-control typeahead2" placeholder="Search Patient..." name="query" />
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

HeaderSearch.contextTypes = {
    router: React.PropTypes.object.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/commons/Header/HeaderSearch.js
 **/